import { Routes } from '@angular/router';

import { AppRoutePath, AppRoutePathParam } from '@falcon/app/app.routing.model';
import { authorizedGuard } from '@falcon/app/core/api/auth/guards/authorised.guard';
import { registrationsAccessGuard } from '@falcon/app/core/api/auth/guards/registrations-access.guard';
import { unauthorizedGuard } from '@falcon/app/core/api/auth/guards/unathorised.guard';

export const ROUTES: Routes = [
  {
    path: AppRoutePath.ROOT,
    pathMatch: 'full',
    redirectTo: AppRoutePath.SEARCH,
  },
  {
    path: AppRoutePath.SEARCH,
    loadChildren: () => import('./modules/search/search.routes').then(m => m.ROUTES),
    canMatch: [unauthorizedGuard],
  },
  {
    path: AppRoutePath.REGISTRATIONS,
    loadChildren: () =>
      import('./modules/registrations/registrations.routes').then(m => m.REGISTRATIONS_ROUTES),
    canMatch: [unauthorizedGuard, registrationsAccessGuard],
  },
  {
    path: `${AppRoutePath.COMPANY}/:${AppRoutePathParam.COMPANY_ID}`,
    loadChildren: () => import('./modules/company/company.routes').then(m => m.ROUTES),
    canMatch: [unauthorizedGuard],
  },
  {
    path: `${AppRoutePath.EMPLOYEE}/:${AppRoutePathParam.EMPLOYEE_ID}`,
    loadChildren: () => import('./modules/employee/employee.routes').then(m => m.ROUTES),
    canMatch: [unauthorizedGuard],
  },
  {
    path: AppRoutePath.CONTRACT,
    loadChildren: () => import('./modules/contract/contract.routes').then(m => m.ROUTES),
    canMatch: [unauthorizedGuard],
  },
  {
    path: AppRoutePath.CREATE_EMPLOYEE,
    loadChildren: () =>
      import('./modules/create-employee/create-employee.routes').then(m => m.ROUTES),
    canMatch: [unauthorizedGuard],
  },
  {
    path: AppRoutePath.INVITATIONS,
    loadChildren: () => import('./modules/invitations/invitations.routes').then(m => m.ROUTES),
  },
  {
    path: `${AppRoutePath.INVITE_EMPLOYEE_REGISTRATION}/:${AppRoutePathParam.INVITATION_ID}`,
    loadChildren: () =>
      import('./modules/invite-employee-registration/invite-employee-registration.routes').then(
        m => m.ROUTES
      ),
  },
  {
    path: `${AppRoutePath.INVITE_EMPLOYEE_MANUAL_REGISTRATION}/:${AppRoutePathParam.INVITATION_ID}`,
    loadComponent: () =>
      import(
        './modules/invite-employee-manual-registration/invite-employee-manual-registration.component'
      ).then(m => m.InviteEmployeeManualRegistrationComponent),
  },
  {
    path: AppRoutePath.AUTH,
    loadChildren: () => import('./modules/auth/auth.routes').then(m => m.ROUTES),
    canMatch: [authorizedGuard],
  },
  {
    path: AppRoutePath.EMPLOYEE_REGISTRATION,
    loadChildren: () =>
      import('./modules/employee-registration/employee-registration.routes').then(m => m.ROUTES),
  },
  {
    path: AppRoutePath.COMPANY_REGISTRATION,
    loadChildren: () =>
      import('./modules/company-registration/company-registration.routes').then(
        m => m.COMPANY_REGISTRATION_ROUTES
      ),
  },
  {
    path: AppRoutePath.UPDATE_REQUIRED,
    loadComponent: () => import('./modules/update-required').then(c => c.UpdateRequiredComponent),
  },
  {
    path: AppRoutePath.EMPLOYEE_USER,
    loadChildren: () => import('./modules/employee-user/employee-user.routes').then(m => m.ROUTES),
    canMatch: [unauthorizedGuard],
  },
  {
    path: AppRoutePath.FLASH,
    loadChildren: () => import('./modules/flash/flash.routes').then(m => m.ROUTES),
    canMatch: [unauthorizedGuard],
  },
  {
    // Helper component for authentication to capture skey query param after BE redirect
    path: 'signin',
    loadComponent: () => import('./modules/signin/signin.component').then(c => c.SigninComponent),
  },
  {
    // BE redirects to this page when login/registration with ItsMe error occurs
    path: 'login-error',
    loadComponent: () =>
      import('./modules/login-error/login-error.component').then(c => c.LoginErrorComponent),
  },
  {
    path: '**',
    redirectTo: AppRoutePath.SEARCH,
  },
];
